




































import Vue from 'vue';
import { Component, Prop } from "vue-property-decorator";
import HeaderComponents from "./../../../../../Assets/Card/Header/Header.vue";
import BodyComponents from "./../../../../../Assets/Card/Body/Body.vue";
import FooterComponents from "./../../../../../Assets/Card/Footer/Footer.vue";

import Axios from 'axios';

/**
 * Component's properties and events
 */
@Component({
    components: {
        HeaderComponents,
        BodyComponents,
        FooterComponents
    }
})
export default class RoleMenuComponent extends Vue {

    data() {
        return this.$store.state.roleMenuIndex;
    }

    //#. The beforeCreate() hook observes data and initialization events in your component.
    beforeCreate() {
    }

    //#. The created() hook is invoked when Vue has set up events and data observation.
    created() {
    }

    //#. The beforeMount() method is invoked after our template has been compiled and our virtual DOM updated by Vue.
    beforeMount() {
    }

    //#. The mounted() method gives you access to templates and enables interaction with the DOM.
    mounted() {


        //this.$store.state.roleMenuIndex.headers = [
        //    {
        //        text: 'MenuConfigId',
        //        // align: 'start',
        //        sortable: false,
        //        value: 'MenuConfigId',
        //        hide: true,
        //        align: ' d-none'
        //    },
        //    { text: 'MenuName', value: 'MenuName', hide: false },
        //    { text: 'View', value: 'View', hide: false },
        //    { text: 'Add', value: 'Add', hide: false },
        //    { text: 'Modify', value: 'Modify', hide: false },
        //    { text: 'Delete', value: 'Delete', hide: false },
        //    { text: 'RestrictedView', value: 'iron', hide: false },
        //    { text: 'Import', value: 'Import', hide: false },
        //    { text: 'Export', value: 'Export', hide: false },
        //    { text: 'BulkUpdate', value: 'BulkUpdate', hide: false },
        //    { text: 'BulkDelete', value: 'BulkDelete', hide: false },
        //    { text: 'Special1', value: 'Special1', hide: false },
        //    { text: 'Special2', value: 'Special2', hide: false },
        //    { text: 'Special3', value: 'Special3', hide: false },
        //    { text: 'Special4', value: 'Special4', hide: false },
        //    { text: 'Special5', value: 'Special5', hide: false },
        //];

        //Axios.get("/api/RoleMenuMapping/List/36/null").then(record => {
        //    try {
        //        debugger;
        //        this.$store.state.roleMenuIndex.items = record.data.Records;
        //        // this._getModuleGroup({ moduleGroups: record.data.modulGrp, menuList: record.data.menu, location: record.data.accountingLocation, modules: record.data.modules });
        //    } catch (error) {
        //        // this._appErrorLog({ error: 'app > _getModuleGroup > ' + error.message });
        //    }
        //}).catch(error => {
        //    //this._appErrorLog({ error: context.actions.list + ' > ' + error.message });
        //});

        //this.$store.state.roleMenuIndex.selected = [];
        //this.$store.state.roleMenuIndex.selectAll = false;
    }

    // #. The beforeUpdate hook runs after data changes on your component and the update cycle begins, right before the DOM is patched and re- rendered.
    beforeUpdate() {
    }

    // #. The updated hook runs after data changes on your component and the DOM re-renders
    updated() {
    }
    fullNameIsExist(itemtext) {
        if (![null, ''].includes(itemtext)) return true
    }
    select() {
        this.$store.state.roleMenuIndex.selected = [];
        if (!this.$store.state.roleMenuIndex.selectAll) {
            for (let i in this.$store.state.roleMenuIndex.items) {
                this.$store.state.roleMenuIndex.selected.push(this.$store.state.roleMenuIndex.items[i].id);
            }
        }
    }
    showButtons() {

        var footerBtnList = {};
        footerBtnList['approve'] = { title: "Approve", module: "timesheetApproval", function: "btn_Approve" };
        footerBtnList['reject'] = { title: "Reject", module: "timesheetApproval", function: "btn_Reject" };
        this.$store.state.dashboard.buttonList = footerBtnList;
    }
    // #. beforeDestroy is fired right before teardown. Your component will still be fully present and functional.
    beforeDestroy() {
    }

    // #. By the time you reach the destroyed hook, there�s pretty much nothing left on your component
    destroyed() {
    }
};
